import React from 'react';
import MyProfessionField from './MyProfessionField';
import MyProfessionFieldsData from '../../data';

const MyProfession = () => {
    return (
        <section className='mx-1 sm:mx-5 overflow-hidden'>
            <h2 className='text-green-600 text-center text-3xl md:text-4xl p-10 Black-Ops-One' data-aos="flip-down" >My Profession</h2>
            <div className='grid md:grid-cols-2 2xl:grid-cols-4 gap-3'>
                {MyProfessionFieldsData.map(myProfessionField => <MyProfessionField
                    key={myProfessionField.fieldName}
                    myProfessionField={myProfessionField}
                >
                </MyProfessionField>)}
            </div>
        </section>
    );
};

export default MyProfession;